import './App.scss';
import './style/style.scss'
import { Provider, useDispatch, useSelector } from 'react-redux';
import AppRouter from './routers';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'primereact/resources/themes/lara-light-blue/theme.css'; 
import 'primereact/resources/primereact.min.css';              
import 'primeicons/primeicons.css';                      
import 'primeflex/primeflex.css';       
import store from './service/store/store';
import {persistor} from './service/store/store';
import { PersistGate } from 'redux-persist/integration/react';

// import './common/translation/i18n'
const  App = () => {

  return (
    <Provider store={store}>
        <AppRouter />
    </Provider>
  //   <Provider store={store}>
  //   <PersistGate loading={null} persistor={persistor}>
  //     <AppRouter />
  //   </PersistGate>
  // </Provider>
  );
}


export default App;

